import React from "react";
import { Form, Switch } from "antd";
import type { FormInstance } from "antd";
import { Localize } from "components/service";

interface IEmailChannelVisibilitySwitchProps {
  form: FormInstance;
}

const EmailChannelVisibilitySwitch: React.FC<
  IEmailChannelVisibilitySwitchProps
> = ({ form }) => {
  const visible = Form.useWatch("is_visible", form) === true;

  return (
    <div className="email-channel-form-state">
      <span className="email-channel-form-label">
        <Localize>EMAIL_CHANNEL.Column_Visibility</Localize>
      </span>
      <div className="email-channel-form-control">
        <Form.Item name="is_visible" valuePropName="checked" noStyle>
          <Switch />
        </Form.Item>
        <span className={visible ? "is-active" : "is-inactive"}>
          <Localize>
            {visible
              ? "EMAIL_CHANNEL.Visibility_Visible"
              : "EMAIL_CHANNEL.Visibility_Hidden"}
          </Localize>
        </span>
      </div>
      <small>
        <Localize>
          {visible
            ? "EMAIL_CHANNEL.Visibility_Visible_Description"
            : "EMAIL_CHANNEL.Visibility_Hidden_Description"}
        </Localize>
      </small>
    </div>
  );
};

export default EmailChannelVisibilitySwitch;
